<template>
  <document-view-with-toolbar @close="closePopup()" :icons="['print']">
    <template v-slot:document>
      <div id="heading">
        <h5 class="event-title" v-if="event.title">{{ event.title }}</h5>
        <img :src="businessLogo" alt="Logo" />
        <div id="heading-copy">
          <h4>{{ businessName }}</h4>
          <p>{{ businessAddress.streetAddress1 }}</p>
          <p v-if="businessAddress.streetAddress2">
            {{ businessAddress.streetAddress2 }}
          </p>
          <p>{{ businessAddress.cityStateZip }}</p>
          <p>{{ formatPhoneNumber(businessPhoneNumber) }}</p>
          <p>{{ businessEmailAddress }}</p>
        </div>
      </div>
      <div id="invoice-information">
        <div class="invoice-information-half">
          <div class="invoice-item" v-if="client">
            <h5>Prepared For:</h5>
            <p>
              <span>{{ client.given_name }} {{ client.family_name }}</span>
            </p>
            <p>{{ formatPhoneNumber(client.phoneNumber) }}</p>
            <p>{{ client.emailAddress }}</p>
          </div>
          <div
            class="invoice-item"
            v-if="event.locations.length && event.locations[0].name"
          >
            <h5>
              Service Location{{ event.locations.length > 1 ? "s:" : ":" }}
            </h5>
            <div v-for="(location, index) in event.locations" :key="index">
              <!-- todo : forgive me and clean this up -->
              <p>
                <span>{{
                  location.api_version === "9-28-2022"
                    ? location.Name
                    : location.name
                }}</span>
              </p>
              <p>
                {{
                  location.api_version === "9-28-2022"
                    ? `${location.AddressNumber} ${location.Street}`
                    : location.address.streetAddress1
                }}
              </p>
              <p>
                {{
                  location.api_version === "9-28-2022"
                    ? `${location.Municipality}, ${location.Region}, ${location.PostalCode}`
                    : location.address.cityStateZip
                }}
              </p>
            </div>
          </div>
          <div class="invoice-item">
            <h5>Invoice Number:</h5>
            <p>
              <span>{{ event.userId }}</span>
            </p>
          </div>
        </div>
        <div class="invoice-information-half">
          <div class="invoice-item">
            <h5>Invoice Date:</h5>
            <p>
              <span>{{ bookDate }}</span>
            </p>
          </div>
          <div class="invoice-item">
            <h5>Event Date:</h5>
            <p>
              <span>{{
                formatDate(event.data ? event.data.date : event.date)
              }}</span>
            </p>
          </div>
          <div class="invoice-item">
            <h5>Final Payment Due:</h5>
            <p>
              <span>{{
                formatDate(
                  finalPaymentDueDate(
                    event,
                    this.$store.getters.finalPaymentSettings
                  )
                )
              }}</span>
            </p>
          </div>
        </div>
      </div>
      <table>
        <tr>
          <th>Description:</th>
          <th>Quantity:</th>
          <th>Unit Price:</th>
          <th>Cost:</th>
        </tr>
        <tr v-for="item in products" :key="item.name">
          <td>{{ item.name }}</td>
          <td>{{ item.pricing.units ? item.pricing.units : 1 }}</td>
          <td>{{ formatPrice(productTotal(item, event)) }}</td>
          <td>{{ formatPrice(productTotal(item, event)) }}</td>
        </tr>
        <tr class="divider">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <th>Subtotal:</th>
          <th></th>
          <th></th>
          <th>{{ formatPrice(subtotal(event)) }}</th>
        </tr>
        <tr>
          <th>Adjustments:</th>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr v-for="item in adjustments" :key="item.id">
          <td>{{ item.name }}:</td>
          <td></td>
          <td></td>
          <td v-if="item.type === 'percentage'">
            {{ item.direction === "charge" ? "+" : "-" }}
            {{ item.amount * 100 }}%
          </td>
          <td v-if="item.type === 'dollar'">
            {{ item.direction === "charge" ? "+" : "-" }} ${{
              item.amount / 100
            }}
          </td>
        </tr>
        <tr>
          <th>Invoice Total:</th>
          <th></th>
          <th></th>
          <th>{{ formatPrice(total(event)) }}</th>
        </tr>
        <tr>
          <th>Payments:</th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
        <tr v-for="item in payments" :key="item.name">
          <td>{{ item.name }}:</td>
          <td></td>
          <td></td>
          <td>-{{ formatPrice(item.amount) }}</td>
        </tr>
        <tr>
          <th>Balance Outstanding:</th>
          <th></th>
          <th></th>
          <th>
            {{ formatPrice(balanceOutstanding(event)) }}
          </th>
        </tr>
        <tr class="divider">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </table>
      <h4>Thank you for choosing {{ businessName }}!</h4>
    </template>
  </document-view-with-toolbar>
</template>

<script>
import {
  productTotal,
  formatPhoneNumber,
  formatDate,
  formatPrice,
  subtotal,
  total,
  balanceOutstanding,
  finalPaymentDueDate,
} from "../../Helpers/invoice.js";

import DocumentViewWithToolbar from "../Documents/DocumentViewWithToolbar.vue";
export default {
  computed: {
    businessAddress() {
      return this.$store.getters.businessAddress;
    },
    businessLogo() {
      return this.$store.getters.businessLogo;
    },
    businessEmailAddress() {
      return this.$store.getters.businessEmailAddress;
    },
    businessPhoneNumber() {
      return this.$store.getters.businessPhoneNumber;
    },
    invoice() {
      return this.event.invoice;
    },
    products() {
      return this.event.invoice
        ? this.event.invoice.products
        : this.event.invoice_products;
    },
    adjustments() {
      return this.event.invoice
        ? this.event.invoice.adjustments
        : this.event.invoice_adjustments;
    },
    payments() {
      return this.event.invoice
        ? this.event.invoice.payments
        : this.event.invoice_payments;
    },
    bookDate() {
      let ms = this.event.userId.replace("event", "");
      let date = new Date(parseInt(ms));
      return date.toLocaleDateString("lookup", {
        day: "numeric",
        year: "numeric",
        month: "long",
      });
    },
    client() {
      let contacts = this.event.contacts.filter((x) => x.role == "client");
      return contacts[0];
    },
  },
  methods: {
    productTotal,
    formatPhoneNumber,
    formatDate,
    formatPrice,
    subtotal,
    total,
    balanceOutstanding,
    finalPaymentDueDate,
    closePopup() {
      this.$emit("close");
    },
  },
  props: ["event"],
  emits: ["close"],
  components: {
    DocumentViewWithToolbar,
  },
};
</script>

<style scoped>
p {
  font-size: 0.65rem;
}

h4 {
  font-size: 0.75rem;
}

h5 {
  font-size: 0.75rem;
}
#invoice-wrapper {
  z-index: 100;
  backdrop-filter: blur(3px);
}

/* todo : fix print */

#heading {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.event-title {
  text-transform: uppercase;
  margin-right: auto;
}

#heading-copy {
  text-align: left;
}

#heading-copy > * {
  margin: 0;
}

#invoice-information {
  display: flex;
  flex-direction: row;
}

.invoice-information-half {
  text-align: left;
  width: 50%;
}

.invoice-item p {
  margin: 5px;
  margin-left: 10px;
}

h5 {
  margin: 15px 0;
}

.invoice-item p span {
  font-weight: 600;
}

img {
  object-fit: contain;
  width: 50px;
  padding: 10px;
  border-right: 1px solid #212121;
  margin-right: 10px;
}

table {
  width: 100%;
  margin: 40px 0;
  color: #212121;
  border-collapse: collapse;
  font-size: 10px;
  text-align: left;
}

th,
td {
  padding: 5px;
  border: 1px solid #212121;
}

.divider {
  background-color: #212121;
  height: 2px;
}
</style>
